import axiosAuthService from '../axios';
import axiosApiService from '../axios';

const AdminUserDetail = {
  AdminDetailUpdate: async function (id, data) {
    try {
      const response = await axiosAuthService.patch(`/auth/users/${id}/`, data);
      console.log('Response:', response.data);
      return response.data; // Assuming the server returns the data
    } catch (error) {
      console.error('Error updating user:', error);
      throw error;
    }
  },

  AdminDetailGet: async function (id) {
    try {
      const response = await axiosAuthService.get(`/auth/users/${id}/`);
      console.log('Response:', response.data);
      return response.data; // Assuming the server returns the data
    } catch (error) {
      console.error('Error getting user details:', error);
      throw error;
    }
  },

  AdminDetailPut: async function (id, data) {
    try {
      const response = await axiosAuthService.put(`/auth/users/${id}/`, data);
      console.log('Response:', response.data);
      return response.data; // Assuming the server returns the data
    } catch (error) {
      console.error('Error putting user details:', error);
      throw error;
    }
  },

  AdminDetailDelete: async function (id) {
    try {
      const response = await axiosAuthService.delete(`/auth/users/${id}/`);
      console.log('Response:', response.data);
      return response.data; // Assuming the server returns the data
    } catch (error) {
      console.error('Error deleting user:', error);
      throw error;
    }
  },
  AdminDetailGetFRTStatus: async function () {
    try {
      const response = await axiosApiService.get(
        `/frt_image_status/get_status/`
      );
      console.log('Response:', response.data);
      return response.data; // Assuming the server returns the data
    } catch (error) {
      console.error('Error getting user details:', error);
      throw error;
    }
  },

  AdminDetailAddFRTImage: async function (formData) {
    try {
      const response = await axiosApiService.post(
        `/frt_image_status/add_image/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      console.log('FRT Image Upload Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error uploading FRT image:', error);
      throw error;
    }
  },
};

export default AdminUserDetail;
